module.exports = __webpack_public_path__ + "static/media/signup.358d1c49.png";